'use client'

import { useState, useEffect } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { ButtonOrLink } from '@/components/ButtonOrLink'
import { useDict } from '@/lib'
import { useTestsAndGamesHref } from '@/hooks/useTestsAndGamesHref'
import s from './Hero.module.scss'

export function Hero() {
  const dict = useDict('homepage/hero')
  const testsAndGamesHref = useTestsAndGamesHref()
  const [socialLinks, setSocialLinks] = useState<Record<string, string> | null>(
    null,
  )

  // Załaduj social media links z bazy danych
  useEffect(() => {
    const loadSocialLinks = async () => {
      try {
        const response = await fetch('/api/global-links')
        if (response.ok) {
          const data = await response.json()
          setSocialLinks(data.socials)
        }
      } catch (error) {
        console.error('Error loading social links:', error)
      }
    }
    loadSocialLinks()
  }, [])

  if (!dict) {
    return null // lub loading spinner
  }

  return (
    <section className={s.hero}>
      <div className={s.content}>
        <div className={s.innerContent}>
          <div className={s.mainText}>
            <h1 className={s.heading}>
              {dict.heading.normal} <span>{dict.heading.bold}</span>
            </h1>
            <span className={s.separator}></span>
            <p className={s.lead}>{dict.lead}</p>
          </div>

          <div className={s.buttons}>
            <ButtonOrLink
              as="link"
              href="/driving-schools"
              variant="primary"
              iconRight="Arrow2Icon"
            >
              {dict.buttons.primary}
            </ButtonOrLink>
            <ButtonOrLink
              as="link"
              href={testsAndGamesHref}
              variant="text"
              classes={s.secondaryBtn}
              iconRight="Arrow2Icon"
            >
              {dict.buttons.secondary}
            </ButtonOrLink>
          </div>

          <div className={s.ctaDesktop}>
            <div className={s.usersSticker}>
              <div className={s.users}>
                <Image
                  src="/photos/client1.webp"
                  alt=""
                  width={48}
                  height={48}
                  loading="lazy"
                />
                <Image
                  src="/photos/client2.webp"
                  alt=""
                  width={48}
                  height={48}
                  loading="lazy"
                />
                <Image
                  src="/photos/client3.webp"
                  alt=""
                  width={48}
                  height={48}
                  loading="lazy"
                />
              </div>
              <p dangerouslySetInnerHTML={{ __html: dict.bottomInfo.text }} />
            </div>

            <div className={s.ctaContent}>
              <p>{dict.ctaLead}</p>
              <ButtonOrLink
                as="link"
                href="/rejestracja"
                variant="text"
                classes={s.pulseLink}
                iconRight="Arrow2Icon"
              >
                {dict.buttons.cta}
              </ButtonOrLink>
            </div>
          </div>
        </div>
      </div>

      <div className={s.imageWrapper}>
        <Image src="/photos/street.webp" alt="" fill priority />

        {/* <div className={s.topRight}>
          <ButtonOrLink as="link" href="/rejestracja?role=osk_owner" variant="secondary" iconRightComponent="Arrow2Icon">
            {dict.buttons.topRight}
          </ButtonOrLink>
        </div> */}

        <div className={s.bottomLinks}>
          {socialLinks?.ig && (
            <ButtonOrLink
              as="link"
              href={socialLinks.ig}
              variant="text"
              iconRight="Arrow2Icon"
              classes={s.imageLinks}
              target="_blank"
              rel="noopener noreferrer"
            >
              {dict.social.instagram}
            </ButtonOrLink>
          )}
          {socialLinks?.fb && (
            <ButtonOrLink
              as="link"
              href={socialLinks.fb}
              variant="text"
              iconRight="Arrow2Icon"
              classes={s.imageLinks}
              target="_blank"
              rel="noopener noreferrer"
            >
              {dict.social.facebook}
            </ButtonOrLink>
          )}
        </div>
      </div>

      <div className={s.ctaMobile}>
        <div className={s.usersSticker}>
          <div className={s.users}>
            <Image
              src="/photos/client1.webp"
              alt=""
              width={60}
              height={60}
              loading="lazy"
            />
            <Image
              src="/photos/client2.webp"
              alt=""
              width={60}
              height={60}
              loading="lazy"
            />
            <Image
              src="/photos/client3.webp"
              alt=""
              width={60}
              height={60}
              loading="lazy"
            />
          </div>
          <p dangerouslySetInnerHTML={{ __html: dict.bottomInfo.text }} />
        </div>
        <p className={s.lead}>{dict.ctaLead}</p>
        <ButtonOrLink
          as="link"
          href="/rejestracja"
          variant="text"
          iconRight="Arrow2Icon"
        >
          {dict.buttons.cta}
        </ButtonOrLink>
      </div>
    </section>
  )
}
